class CountrySelector extends HTMLElement {
    constructor(el) {
        super();

        if (!el) return;

        this.el = el;
        this.body = document.querySelector('body');
        this.form = this.el.querySelector('.js-country-selector-form');
        this.formInput = this.el.querySelector('.js-country-selector-form-input');
        this.formOpener = this.el.querySelector('.js-country-selector-form-opener');
        this.formToggle = this.el.querySelectorAll('.js-country-selector-form-toggle');
        this.formContainer = this.el.querySelector('.js-country-selector-form-container');
        this.formOverlay = this.el.querySelector('.js-country-selector-form-overlay');
        this.countryHyperlinks = [...this.el.querySelectorAll('.js-country-selector-lang-hyperlink')];

        this.formToggle.forEach(item => item.addEventListener('click', this.onOpenerClick.bind(this)));
        this.countryHyperlinks.forEach(item => item.addEventListener('click', this.onCountryHyperlinkClick.bind(this)));
    }

    onOpenerClick(event) {
        event.preventDefault();

        if (this.formContainer?.classList.contains('large:translate-x-0')) {
            this.body.classList.remove('overflow-hidden');
            this.formContainer.classList.remove('largeMax:trasnlate-y-0', 'large:translate-x-0');
            this.formContainer.classList.add('largeMax:translate-y-full', 'large:translate-x-full');
            this.formOverlay.classList.add('translate-x-full');
            this.formOverlay.classList.remove('translate-x-0');
            this.formOpener.setAttribute('aria-expanded', true);
            this.formContainer.setAttribute('aria-hidden', false);
        } else {
            this.body.classList.add('overflow-hidden');
            this.formContainer.classList.add('largeMax:trasnlate-y-0', 'large:translate-x-0');
            this.formContainer.classList.remove('largeMax:translate-y-full', 'large:translate-x-full');
            this.formOverlay.classList.remove('translate-x-full');
            this.formOverlay.classList.add('translate-x-0');
            this.formOpener.setAttribute('aria-expanded', false);
            this.formContainer.setAttribute('aria-hidden', true);
        }
    }

    onCountryHyperlinkClick(event) {
        event.preventDefault();

        this.formInput.value = event.currentTarget.dataset.value;
        localStorage.selectedCountry = event.currentTarget.dataset.value;
        if (this.form) this.form.submit();
    }
}

customElements.define('country-selector', CountrySelector);

export {
    CountrySelector
}
